import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserSettingsEntityState } from './user-settings-entity.state';
import { UserAccountState } from '../user-account.state';

const selectUserAccountState = createFeatureSelector('userAccount');

export const selectUserSettingsEntityState = createSelector(
  selectUserAccountState,
  (userAccountState: UserAccountState) => userAccountState.userSettingsEntityState
);

export const selectUserSettingsEntity = createSelector(
  selectUserSettingsEntityState,
  (state: UserSettingsEntityState) => state.userSettingsEntity
);

export const selectLoading = createSelector(
  selectUserSettingsEntityState,
  (state: UserSettingsEntityState) => state.userSettingsEntityLoading
);
